/**
 * POS cihaz entegrasyonu enumları (arka uç: DbEnums, pos-entegrasyonu.md). Sayısal
 * değerler sunucudakiyle birebir aynı; API enumları sayı olarak döndürüyor.
 */

export enum PosDeviceProviderType {
  None = 0,
  /** Geliştirme/deneme: gerçek cihaz yok, sonuç tutarın kuruşuna göre üretilir. */
  Mock = 1,
  PavoUniCloud = 2,
}

export enum PosPairingStatus {
  NotPaired = 0,
  /** Kod üretildi, cihaz ekranında onay bekleniyor. */
  Pending = 1,
  Paired = 2,
  Revoked = 3,
}

export enum PosTransactionStatus {
  Unknown = 0,
  /** Gönderildi, cihaz henüz almadı. */
  Pending = 1,
  /** Cihaz ekranında, kart bekleniyor. */
  InProgress = 2,
  Approved = 3,
  Declined = 4,
  Cancelled = 5,
  /** Cihazda askıya alındı — kasiyer cihazdan devam ettirebilir. */
  Suspended = 6,
}

export enum PosDocumentStatus {
  Unknown = 0,
  Pending = 1,
  Created = 2,
  /** Ödeme alındı ama belge oluşmadı — cihazdan belge tamamlanmalı. */
  Failed = 3,
  Cancelled = 4,
}

export enum PosTransactionType {
  Sale = 1,
  /** Onaylı satışın cihazdan iptali. */
  Void = 2,
  /** Onaylı satıştan satır iadesi; satırları iade edilen satırlardır (K24). */
  Refund = 3,
}

/** Kart satışında belge satırlarının kurulma yolu (K16). */
export enum PosLineMode {
  /** Satışın ürünleri; has/işçilik e-faturadaki kuralla. */
  RealProducts = 1,
  /** E-fatura emtia kuralı + otomatik fiyatlama. */
  CommodityRules = 2,
}

/** Emtia kuralının uygulandığı yer (bit bayrağı). */
export enum CommodityRuleScope {
  Bank = 1,
  Pos = 2,
  All = 3,
}

export const PosDeviceProviderLabels: Record<number, string> = {
  [PosDeviceProviderType.None]: '—',
  [PosDeviceProviderType.Mock]: 'Deneme (Mock)',
  [PosDeviceProviderType.PavoUniCloud]: 'Pavo UniCloud',
};

export const PosPairingStatusLabels: Record<number, string> = {
  [PosPairingStatus.NotPaired]: 'Eşleşmedi',
  [PosPairingStatus.Pending]: 'Onay bekliyor',
  [PosPairingStatus.Paired]: 'Eşleşti',
  [PosPairingStatus.Revoked]: 'Kaldırıldı',
};

export const PosTransactionStatusLabels: Record<number, string> = {
  [PosTransactionStatus.Unknown]: 'Bilinmiyor',
  [PosTransactionStatus.Pending]: 'Gönderildi',
  [PosTransactionStatus.InProgress]: 'Cihazda',
  [PosTransactionStatus.Approved]: 'Onaylandı',
  [PosTransactionStatus.Declined]: 'Reddedildi',
  [PosTransactionStatus.Cancelled]: 'İptal',
  [PosTransactionStatus.Suspended]: 'Askıda',
};

/**
 * Cihazdan iptal işleminde durumların anlamı satıştakinden farklı: "Onaylandı" iptalin
 * gerçekleştiği (karta iade edildiği), "Reddedildi" iptalin yapılamadığı demektir.
 */
export const PosVoidStatusLabels: Record<number, string> = {
  ...PosTransactionStatusLabels,
  [PosTransactionStatus.Approved]: 'İptal edildi',
  [PosTransactionStatus.Declined]: 'İptal başarısız',
  [PosTransactionStatus.Cancelled]: 'Geri çekildi',
};

/** Satır iadesinde "Onaylandı" iadenin yapıldığı, "Reddedildi" yapılamadığı demektir. */
export const PosRefundStatusLabels: Record<number, string> = {
  ...PosTransactionStatusLabels,
  [PosTransactionStatus.Approved]: 'İade edildi',
  [PosTransactionStatus.Declined]: 'İade başarısız',
  [PosTransactionStatus.Cancelled]: 'Geri çekildi',
};

export function posTransactionStatusLabel(type: PosTransactionType, status: PosTransactionStatus): string {
  const labels = type === PosTransactionType.Void ? PosVoidStatusLabels
    : type === PosTransactionType.Refund ? PosRefundStatusLabels
    : PosTransactionStatusLabels;
  return labels[status];
}

export const PosDocumentStatusLabels: Record<number, string> = {
  [PosDocumentStatus.Unknown]: '—',
  [PosDocumentStatus.Pending]: 'Bekliyor',
  [PosDocumentStatus.Created]: 'Oluştu',
  [PosDocumentStatus.Failed]: 'Oluşmadı',
  [PosDocumentStatus.Cancelled]: 'İptal',
};

export const PosLineModeLabels: Record<number, string> = {
  [PosLineMode.RealProducts]: 'Gerçek ürünler',
  [PosLineMode.CommodityRules]: 'Emtia kuralları',
};

export const CommodityRuleScopeLabels: Record<number, string> = {
  [CommodityRuleScope.Bank]: 'Banka',
  [CommodityRuleScope.Pos]: 'POS',
  [CommodityRuleScope.All]: 'Banka + POS',
};

/** Durum rozetinin bootstrap rengi. */
export function posTransactionStatusColor(status: PosTransactionStatus): string {
  switch (status) {
    case PosTransactionStatus.Approved: return 'success';
    case PosTransactionStatus.Declined: return 'danger';
    case PosTransactionStatus.Cancelled: return 'secondary';
    case PosTransactionStatus.Suspended: return 'warning';
    case PosTransactionStatus.InProgress: return 'info';
    default: return 'primary';
  }
}
